/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

Sentry.init({
  dsn: "https://d1ed5cdf3b55a7ca3fe57ab28b409c1b@sentry.xoverservices.com/12",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
